// Keep the following in sync with packages/rum-recorder/src/index.ts
export { datadogRum } from './boot/rum.entry';
//# sourceMappingURL=index.js.map